import React from "react";

function FooterLinks() {
  return (
    <ul className="footerLinksContainer">
      <a
        href="http://"
        className="singleFooterLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <li>privacy policy</li>
      </a>
      <a
        href="http://"
        className="singleFooterLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <li>terms and conditions</li>
      </a>
      <a
        href="http://"
        className="singleFooterLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <li>contact us</li>
      </a>
      <a
        href="http://"
        className="singleFooterLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <li>careers</li>
      </a>
    </ul>
  );
}

export default FooterLinks;
